import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import {
  useMsal,
  useIsAuthenticated,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";

import "./App.scss";

/* Import API */
import { userAvtorizacijeUpn } from "./listOfApi";
import { fetchGET } from "./apiHelper";

/*Component Import*/
import Header from "./components/Header";
import SidebarNavigation from "./components/SidebarNavigation";
import AuthorisationComponent from "./components/AuthorisationComponent";
import LoginComponent from "./components/LoginComponent";
import UserRoleProvider from "./context/UserRoleProvider";

/*React-bootstrap components */
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

const App = () => {
  const [userAuthorisation, setUserAuthorisation] = useState({});
  const { accounts, instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const loadUserAuthorisation = () => {
    if (!isAuthenticated || accounts.length === 0) {
      return;
    }

    const cached = sessionStorage.getItem("userAuthorisation");
    if (cached) {
      setUserAuthorisation(JSON.parse(cached));
      return;
    }

    const username = accounts[0].username;
    fetchGET(`${userAvtorizacijeUpn}/${username}`).then((user) => {
      if (user !== 0) {
        const authData = {
          admin: user.admin,
          skrbnik: user.skrbnik,
          clanicaID: user.clanicaID,
          programi: user.programi,
          razpisi: user.razpisi,
          aktualniRazpisi: user.aktualniRazpisi,
          projekti: user.projekti,
          partnerji: user.partnerji,
          deminimis: user.deminimis ?? user.Deminimis ?? 0,
        };
        sessionStorage.setItem("userAuthorisation", JSON.stringify(authData));
        setUserAuthorisation(authData);
      }
    });
  };

  // Clear cache only on real logout, not on MSAL's silent re-auth during refresh
  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGOUT_SUCCESS) {
        sessionStorage.removeItem("userAuthorisation");
        setUserAuthorisation({});
      }
    });
    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    loadUserAuthorisation();
  }, [isAuthenticated]);

  return (
    <Router>
      <Container fluid>
        <Row>
          <Header isAuthenticated={isAuthenticated} />
        </Row>
        <Row className="mt-5 ml-5"></Row>
        <Row>
          <UnauthenticatedTemplate>
            <LoginComponent />
          </UnauthenticatedTemplate>
          <AuthenticatedTemplate>
            <UserRoleProvider>
              <SidebarNavigation role={userAuthorisation} />
              <AuthorisationComponent role={userAuthorisation} />
            </UserRoleProvider>
          </AuthenticatedTemplate>
        </Row>
      </Container>
    </Router>
  );
};

export default App;
